/**
 * MobileShell Component
 * Feature: 012-desktop-mobile-shells
 * User Story: US1 - Seamless Shell Adaptation
 *
 * Layout structure for mobile viewport (< 768px).
 * Includes header, main content area, and bottom navigation.
 */

import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from '../../components/header/header.component';
import { BottomNavComponent } from '../../components/bottom-nav/bottom-nav.component';

@Component({
  selector: 'app-mobile-shell',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    HeaderComponent,
    BottomNavComponent
  ],
  templateUrl: './mobile-shell.component.html',
  styleUrl: './mobile-shell.component.scss'
})
export class MobileShellComponent {}
